// Calendly
window.addEventListener("DOMContentLoaded", function() {
  const links = document.querySelectorAll('a[href*="#"]');

  for(const link of links) {
    const modalID = link.href.split('#')[1];
    const targetModal = document.querySelector(`[data-modal-id="${modalID}"]`);

    if(!targetModal) {
      continue
    }

    link.addEventListener("click", function(e) {
      e.preventDefault();
      targetModal.setAttribute("open", "");
    });
  }
});

// RAO Accordion
class RAOAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const openBtn  = this.querySelector("[data-open-button]");
    const closeBtn = this.querySelector("[data-close-button]");

    this.content = this.querySelector("[data-content]");
    this.inner   = this.querySelector("[data-inner]");

    if(openBtn) {
      openBtn.addEventListener("click", this.open.bind(this));
    }

    if(closeBtn) {
      closeBtn.addEventListener("click", this.close.bind(this));
    }
  }

  open() {
    this.content.style.setProperty("--inner-height", `${this.inner.getBoundingClientRect().height}px`);
    this.classList.add("open");
  }

  close() {
    this.classList.remove("open");
  }
}

customElements.define("rao-accordion", RAOAccordion);

// RAO Scroll Nav Bar

class RAOScrollNavBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(!this.hasAttribute("aria-controls")) {
      console.error("RAOScrollNavBar: Element must have a valid aria-controls attribute pointing to a scroll-carousel's id");
      return
    }

    const scrollID = this.getAttribute("aria-controls");
    this.carouselElement = document.querySelector(`scroll-carousel[id="${scrollID}"]`);
    if(!this.carouselElement) {
      console.error("RAOScrollNavBar: Element must have a valid aria-controls attribute pointing to a scroll-carousel's id");
      return
    }

    this.carouselElement.addEventListener("carousel:change", this.onCarouselChange.bind(this));
  }

  onCarouselChange(e) {
    this.style.setProperty("--curr-index", e.detail.index + 1);
  }
}

customElements.define("rao-scroll-nav-bar", RAOScrollNavBar);

function debounce(callback, delay = 150) {
  let timer;

  return (...args) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => callback(...args), delay);
  };
}

// Collection banner RAO (desktop)

class CollectionBannerDescription extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector("[data-description-content]");
    this.text = this.querySelector("[data-description-text]");
    this.button = this.querySelector("[data-read-more-button]");
    this.collapsedLines = parseInt(this.dataset.collapsedLines || "3", 10);
    this.readMoreLabel = this.dataset.readMore || "Read more";
    this.readLessLabel = this.dataset.readLess || "Read less";
    this.hideReadLess = this.dataset.hideReadLess === "true";
    this.expanded = false;

    this.onToggleClick = () => this.toggle();
    this.onResize = debounce(() => this.handleResize());
    this.lastWidth = window.innerWidth;

    this.button?.addEventListener("click", this.onToggleClick);
    window.addEventListener("resize", this.onResize);

    window.requestAnimationFrame(() => this.initialize());
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
    this.button?.removeEventListener("click", this.onToggleClick);
  }

  handleResize() {
    const width = window.innerWidth;

    if (width === this.lastWidth) {
      return;
    }

    this.lastWidth = width;
    this.reinitialize();
  }

  isActive() {
    return this.getClientRects().length > 0;
  }

  resetState() {
    this.expanded = false;
    this.classList.remove("is-expanded");

    if (this.content) {
      this.content.style.maxHeight = "";
    }

    if (this.button) {
      this.button.setAttribute("aria-expanded", "false");
      this.setButtonLabel(this.readMoreLabel);
    }
  }

  reinitialize() {
    this.resetState();

    window.requestAnimationFrame(() => {
      if (!this.isActive()) {
        return;
      }

      this.initialize();
    });
  }

  initialize() {
    if (!this.content || !this.button) {
      return;
    }

    this.fullHeight = this.content.scrollHeight;
    this.collapsedHeight = this.getCollapsedHeight();

    if (this.fullHeight <= this.collapsedHeight + 2) {
      this.button.hidden = true;
      this.content.style.maxHeight = "none";
      this.classList.add("is-initialized");
      return;
    }

    this.content.style.maxHeight = `${this.collapsedHeight}px`;
    this.button.hidden = false;
    this.button.setAttribute("aria-expanded", "false");
    this.setButtonLabel(this.readMoreLabel);
    this.classList.add("is-initialized");
  }

  getCollapsedHeight() {
    let styles = window.getComputedStyle(this.text);
    let imageHeight = 0;

    if(this.content.children.length > 0) {
      const childrenNodeName = this.text.children[0].nodeName.toLowerCase();
      const childrenChildrenNodeName = this.text.children[0].children[0]?.nodeName.toLowerCase();
      //  console.log('childrenNodeName -> ', childrenNodeName);
      //  console.log('childrenChildrenNodeName -> ', childrenChildrenNodeName);

      if (childrenNodeName == 'img') {
        imageHeight = Math.ceil(this.text.children[0].getBoundingClientRect().height);
      }

      if (childrenChildrenNodeName == 'img') {
        imageHeight = Math.ceil(this.text.children[0].children[0].getBoundingClientRect().height);
      }
      // console.log('this.content.children[0] => ', this.content.children[0])
      // console.log('getComputedStyle => ', window.getComputedStyle(this.content.children[0]))
      styles = window.getComputedStyle(this.text.children[0]);
    }

    const lineHeight = parseFloat(styles.lineHeight);

    if (Number.isNaN(lineHeight)) {
      return this.text.scrollHeight;
    }

    return Math.ceil(imageHeight > 0 ? imageHeight : (lineHeight * this.collapsedLines));
  }

  toggle() {
    if (this.expanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    this.expanded = true;
    this.classList.add("is-expanded");
    this.content.style.maxHeight = `${this.fullHeight}px`;
    this.button.setAttribute("aria-expanded", "true");

    if (this.hideReadLess) {
      this.button.hidden = true;
    } else {
      this.button.hidden = false;
      this.setButtonLabel(this.readLessLabel);
    }
  }

  collapse() {
    this.expanded = false;
    this.classList.remove("is-expanded");
    this.content.style.maxHeight = `${this.collapsedHeight}px`;
    this.button.hidden = false;
    this.button.setAttribute("aria-expanded", "false");
    this.setButtonLabel(this.readMoreLabel);
  }

  setButtonLabel(label) {
    const content = this.button.querySelector("button-content");

    if (content) {
      content.textContent = label;
    } else {
      this.button.textContent = label;
    }
  }
}

customElements.define("collection-banner-description", CollectionBannerDescription);

// Collection banner RAO (mobile)

class CollectionBannerDescriptionMobile extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector("[data-description-content]");
    this.text = this.querySelector("[data-description-text]");
    this.readMoreButton = this.querySelector("[data-read-more-button]");
    this.readLessButton = this.querySelector("[data-read-less-button]");
    this.readMoreLabel = this.dataset.readMore || "Read more";
    this.readLessLabel = this.dataset.readLess || "Read less";
    this.hideReadLess = this.dataset.hideReadLess === "true";
    this.expanded = false;
    this.isFinishingCollapse = false;

    this.onReadMoreClick = () => this.expand();
    this.onReadLessClick = () => this.collapse();
    this.onResize = debounce(() => this.handleResize());
    this.lastWidth = window.innerWidth;

    this.readMoreButton?.addEventListener("click", this.onReadMoreClick);
    this.readLessButton?.addEventListener("click", this.onReadLessClick);
    window.addEventListener("resize", this.onResize);

    window.requestAnimationFrame(() => this.initialize());
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
    this.readMoreButton?.removeEventListener("click", this.onReadMoreClick);
    this.readLessButton?.removeEventListener("click", this.onReadLessClick);
    window.clearTimeout(this.collapseFallbackTimer);
  }

  handleResize() {
    const width = window.innerWidth;

    if (width === this.lastWidth) {
      return;
    }

    this.lastWidth = width;
    this.reinitialize();
  }
  
  isActive() {
    return this.getClientRects().length > 0;
  }

  resetState() {
    window.clearTimeout(this.collapseFallbackTimer);
    this.isFinishingCollapse = false;
    this.expanded = false;
    this.classList.remove("is-expanded");

    if (this.content) {
      this.content.style.maxHeight = "";
    }

    if (this.readMoreButton) {
      this.readMoreButton.hidden = true;
      this.readMoreButton.setAttribute("aria-expanded", "false");
      this.readMoreButton.textContent = this.readMoreLabel;
    }

    if (this.readLessButton) {
      this.readLessButton.hidden = true;
      this.readLessButton.textContent = this.readLessLabel;
    }
  }

  reinitialize() {
    this.resetState();

    window.requestAnimationFrame(() => {
      if (!this.isActive()) {
        return;
      }

      this.initialize();
    });
  }

  initialize() {
    if (!this.content || !this.readMoreButton) {
      return;
    }

    this.collapsedHeight = this.getLineHeight();
    this.fullHeight = this.measureFullHeight();

    if (!this.needsToggle()) {
      this.readMoreButton.hidden = true;

      if (this.readLessButton) {
        this.readLessButton.hidden = true;
      }

      this.content.style.maxHeight = "none";
      return;
    }

    this.collapse(false);
  }

  getLineHeight() {
    let styles = window.getComputedStyle(this.text);
    let imageHeight = 0;

    if(this.content.children.length > 0) {
      const childrenNodeName = this.text.children[0].nodeName.toLowerCase();
      const childrenChildrenNodeName = this.text.children[0].children[0]?.nodeName.toLowerCase();

      //console.log('childrenNodeName -> ', childrenNodeName);
      //console.log('childrenChildrenNodeName -> ', childrenChildrenNodeName);

      if (childrenNodeName == 'img') {
        imageHeight = Math.ceil(this.text.children[0].getBoundingClientRect().height);
      }

      if (childrenChildrenNodeName == 'img') {
        imageHeight = Math.ceil(this.text.children[0].children[0].getBoundingClientRect().height);
      }
      
      styles = window.getComputedStyle(this.text.children[0]);
    }

    const lineHeight = parseFloat(styles.lineHeight);

    if (Number.isNaN(lineHeight)) {
      return this.text.scrollHeight;
    }
    return Math.ceil(imageHeight > 0 ? imageHeight : lineHeight);
    //return Math.ceil(lineHeight);
  }

  measureFullHeight() {
    const wasExpanded = this.classList.contains("is-expanded");
    const previousMaxHeight = this.content.style.maxHeight;

    this.classList.add("is-expanded");
    this.content.style.maxHeight = "none";
    const fullHeight = this.content.scrollHeight;

    if (!wasExpanded) {
      this.classList.remove("is-expanded");
    }

    this.content.style.maxHeight = previousMaxHeight;

    return fullHeight;
  }

  needsToggle() {
    return this.fullHeight > this.collapsedHeight + 2 || this.content.scrollWidth > this.content.clientWidth + 1;
  }

  expand() {
    window.clearTimeout(this.collapseFallbackTimer);
    this.isFinishingCollapse = false;
    this.expanded = true;
    this.classList.add("is-expanded");
    this.content.style.maxHeight = `${this.collapsedHeight}px`;
    this.content.offsetHeight;
    this.content.style.maxHeight = `${this.fullHeight}px`;
    this.readMoreButton.hidden = true;
    this.readMoreButton.setAttribute("aria-expanded", "true");

    if (this.readLessButton) {
      if (this.hideReadLess) {
        this.readLessButton.hidden = true;
      } else {
        this.readLessButton.hidden = false;
        this.readLessButton.textContent = this.readLessLabel;
      }
    }
  }

  collapse(animate = true) {
    if (!animate || !this.expanded) {
      this.finishCollapse();
      return;
    }

    this.expanded = false;

    if (this.readLessButton) {
      this.readLessButton.hidden = true;
    }

    this.content.style.maxHeight = `${this.fullHeight}px`;
    this.content.offsetHeight;
    this.content.style.maxHeight = `${this.collapsedHeight}px`;

    const onTransitionEnd = (event) => {
      if (event.target !== this.content || event.propertyName !== "max-height") {
        return;
      }

      this.content.removeEventListener("transitionend", onTransitionEnd);
      window.clearTimeout(this.collapseFallbackTimer);
      this.finishCollapse();
    };

    this.content.addEventListener("transitionend", onTransitionEnd);
    this.collapseFallbackTimer = window.setTimeout(() => {
      this.content.removeEventListener("transitionend", onTransitionEnd);
      this.finishCollapse();
    }, 500);
  }

  finishCollapse() {
    if (this.isFinishingCollapse) {
      return;
    }

    this.isFinishingCollapse = true;
    window.clearTimeout(this.collapseFallbackTimer);
    this.expanded = false;
    this.classList.remove("is-expanded");
    this.content.style.maxHeight = `${this.collapsedHeight}px`;
    this.readMoreButton.hidden = false;
    this.readMoreButton.setAttribute("aria-expanded", "false");
    this.readMoreButton.textContent = this.readMoreLabel;

    if (this.readLessButton) {
      this.readLessButton.hidden = true;
    }
  }
}

customElements.define("collection-banner-description-mobile", CollectionBannerDescriptionMobile);

class CollectionShowHideFiltersButton extends HTMLElement {
  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.onChange);
    this.updateButtonState();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onChange);
  }

  updateButtonState() {
    const isShown = this.dataset.showFilters === "true";
    const labelElement = this.querySelector("[data-filter-button-label]");

    this.classList.toggle("is-filters-shown", isShown);
    this.setAttribute("aria-expanded", isShown ? "true" : "false");

    if (labelElement) {
      labelElement.textContent = isShown ? this.dataset.labelHide : this.dataset.labelShow;
    }
  }

  onChange() {
    const attributes = {};

    if (this.dataset.showFilters === "true") {
      attributes.collection_show_filters = "false";
      this.setAttribute("data-show-filters", "false");
    } else if (this.dataset.showFilters === "false") {
      attributes.collection_show_filters = "true";
      this.setAttribute("data-show-filters", "true");
    }

    fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        attributes
      })
    });

    const collection = this.closest(".collection");
    const collectionSidebar = collection?.querySelector(".collection__sidebar");
    const productList = collection?.querySelector(".product-list");

    if (!collectionSidebar || !productList) {
      this.updateButtonState();
      return;
    }

    if (this.dataset.showFilters === "true") {
      if (collectionSidebar.classList.contains("collection__sidebar-hidden")) {
        collectionSidebar.classList.remove("collection__sidebar-hidden");
        productList.classList.add("productList__sidebar-shown");
      }
    } else if (this.dataset.showFilters === "false") {
      if (!collectionSidebar.classList.contains("collection__sidebar-hidden")) {
        collectionSidebar.classList.add("collection__sidebar-hidden");
        productList.classList.remove("productList__sidebar-shown");
      }
    }

    if (typeof productList.reveal === "function") {
      productList.reveal();
    }

    this.updateButtonState();
  }
}

if (!window.customElements.get("collection-show-hide-filters-button")) {
  window.customElements.define("collection-show-hide-filters-button", CollectionShowHideFiltersButton);
}

function refreshFacetsRaoAccordionHeight(container) {
  const details = container.closest("accordion-disclosure")?.querySelector("details");

  if (!details?.open) {
    return;
  }

  details.style.removeProperty("height");
  details.style.removeProperty("overflow");
}

function toggleFacetsRaoShowMore(event) {
  const button = event.target.closest(".facets-rao [data-show-more-button]");

  if (!button) {
    return;
  }

  const container = button.closest("facets-rao-show-more");

  if (!container) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  const isExpanded = container.classList.toggle("is-expanded");
  const labelElement = button.querySelector(".facets-rao-show-more__button-label");
  const showMoreLabel = button.dataset.showMoreLabel || "";
  const showLessLabel = button.dataset.showLessLabel || "";

  if (labelElement && showMoreLabel && showLessLabel) {
    labelElement.textContent = isExpanded ? showLessLabel : showMoreLabel;
  }

  refreshFacetsRaoAccordionHeight(container);
  window.requestAnimationFrame(() => refreshFacetsRaoAccordionHeight(container));
}

document.addEventListener("click", toggleFacetsRaoShowMore, true);

if (!window.customElements.get("facets-rao-show-more")) {
  window.customElements.define("facets-rao-show-more", class extends HTMLElement {});
}

class TimelineRaoSlider extends HTMLElement {
  connectedCallback() {
    this.carousel = this.querySelector("scroll-carousel");
    this.buttons = [...this.querySelectorAll(".timeline__nav button[data-block-id]")];
    this.slides = [...this.querySelectorAll(".timeline-rao-slider__slide")];

    if (!this.carousel || this.buttons.length === 0) {
      return;
    }

    this.onNavClick = (event) => {
      const button = event.target.closest("button[data-block-id]");

      if (!button || button.getAttribute("aria-current") === "true") {
        return;
      }

      this.select(button.dataset.blockId);
    };

    this.onCarouselChange = (event) => {
      const blockId = event.detail.cell?.dataset.blockId;

      if (blockId) {
        this.updateNav(blockId);
      }
    };

    this.onBlockSelect = (event) => {
      if (event.detail?.blockId) {
        this.select(event.detail.blockId, { instant: event.detail.load });
      }
    };

    this.addEventListener("click", this.onNavClick);
    this.carousel.addEventListener("carousel:change", this.onCarouselChange);
    this.closest(".shopify-section")?.addEventListener("shopify:block:select", this.onBlockSelect);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onNavClick);
    this.carousel?.removeEventListener("carousel:change", this.onCarouselChange);
    this.closest(".shopify-section")?.removeEventListener("shopify:block:select", this.onBlockSelect);
  }

  select(blockId, { instant = false } = {}) {
    const index = this.slides.findIndex((slide) => slide.dataset.blockId === blockId);

    if (index < 0) {
      return;
    }

    this.carousel.select(index, { instant });
    this.updateNav(blockId);
  }

  updateNav(blockId) {
    this.buttons.forEach((button) => {
      const isCurrent = button.dataset.blockId === blockId;
      button.setAttribute("aria-current", isCurrent ? "true" : "false");

      if (!isCurrent || !button.offsetParent) {
        return;
      }

      if (button.offsetParent.scrollWidth !== button.offsetParent.clientWidth) {
        button.offsetParent.scrollTo({
          left: button.offsetLeft - button.offsetParent.clientWidth / 2 + button.clientWidth / 2,
          behavior: "smooth"
        });
      }
    });
  }
}

if (!window.customElements.get("timeline-rao-slider")) {
  window.customElements.define("timeline-rao-slider", TimelineRaoSlider);
}